var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoUndelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 285,
    viewBox: "0 0 285 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_928_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.732 66.214L207.726 52.913L209.178 49.856C215.532 36.477 209.817 20.422 196.438 14.067L172.316 2.61098C165.836 -0.468018 158.545 -0.836018 151.784 1.56898C145.024 3.97498 139.606 8.86998 136.528 15.351L135.076 18.408L107.07 5.10598C92.417 -1.85202 74.831 4.40798 67.87 19.061L60.7 34.155C59.562 36.551 59.423 39.301 60.312 41.799C61.202 44.298 63.047 46.341 65.443 47.479L139.661 82.729H41.481C38.684 82.729 36.016 83.9 34.123 85.958C32.229 88.017 31.284 90.773 31.516 93.56L44.659 251.266C46.189 269.628 61.821 284.011 80.247 284.011H153.787C172.212 284.011 187.844 269.628 189.374 251.266L200.992 111.858L229.197 125.254C230.582 125.912 232.042 126.223 233.48 126.223C237.22 126.223 240.808 124.115 242.52 120.511L249.689 105.418C256.646 90.761 250.386 73.175 235.732 66.214ZM154.594 23.931C155.38 22.276 156.764 21.026 158.49 20.41C160.219 19.796 162.08 19.889 163.735 20.677L187.856 32.132C191.274 33.756 192.734 37.858 191.111 41.276L189.659 44.333L153.141 26.989L154.594 23.931ZM169.441 249.604C168.768 257.681 161.891 264.009 153.786 264.009H80.246C72.14 264.009 65.263 257.681 64.59 249.604L52.35 102.728H181.682L169.441 249.604ZM231.62 96.835L228.742 102.895L83.057 33.701L85.936 27.64C88.165 22.945 93.799 20.942 98.49 23.171L227.151 84.279C231.845 86.509 233.85 92.142 231.62 96.835Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_928_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 284.011,
    height: 284.011,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUndelete);
export default __webpack_public_path__ + "static/media/ico_undelete.b7c8b4826b27ea57964dd6f2706d13e8.svg";
export { ForwardRef as ReactComponent };